import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <>
      {/* ==================== Footer Two Start Here ==================== */}
      <footer className='footer py-32 overflow-hidden bg-gray-100 border-top border-gray-200'>
        <div className='container container-lg'>
          <div className='footer-item-two-wrapper d-flex align-items-start flex-wrap'>
            <div className='footer-item max-w-260'>
              <div className='footer-item__logo mb-24'>
                <Link to='/'>
                  <img src='/assets/images/logo/logo.png'
                    alt='Vedhas Culture' 
                    style={{ maxWidth: '100%', width: '180px', height: 'auto' }}
                  />
                </Link>
              </div>
              <p className='mb-24 text-gray-800 opacity-75'>
                VedhaCultures brings you the finest selection of authentic cultural products,
                handcrafted with tradition and quality in mind.
              </p>
            </div>
            <div className='footer-item'>
              <h6 className='footer-item__title text-main-600 fw-bold'>Quick Links</h6>
              <ul className='footer-menu'>
                <li className='mb-16'>
                  <Link to='/' className='text-gray-800 opacity-75 hover-opacity-100 hover-text-main-700 transition-2'>
                    Home
                  </Link>
                </li>
                <li className='mb-16'>
                  <Link to='/shop' className='text-gray-800 opacity-75 hover-opacity-100 hover-text-main-700 transition-2'>
                    Shop
                  </Link>
                </li>
                <li className='mb-16'>
                  <Link to='/workshops' className='text-gray-800 opacity-75 hover-opacity-100 hover-text-main-700 transition-2'>
                    Workshops
                  </Link>
                </li>
                <li className='mb-16'>
                  <Link to='/about' className='text-gray-800 opacity-75 hover-opacity-100 hover-text-main-700 transition-2'>
                    About Us
                  </Link>
                </li>
                <li className='mb-16'>
                  <Link to='/contact' className='text-gray-800 opacity-75 hover-opacity-100 hover-text-main-700 transition-2'>
                    Contact Us
                  </Link>
                </li>
                <li className='mb-16'>
                  <Link to='/privacy-policy' className='text-gray-800 opacity-75 hover-opacity-100 hover-text-main-700 transition-2'>
                    Privacy Policy
                  </Link>
                </li>
              </ul>
            </div>
            <div className='footer-item'>
              <h6 className='footer-item__title text-main-600 fw-bold'>My Account</h6>
              <ul className='footer-menu'>
                <li className='mb-16'>
                  <Link to='/account' className='text-gray-800 opacity-75 hover-opacity-100 hover-text-main-700 transition-2'>
                    My Account
                  </Link>
                </li>
                <li className='mb-16'>
                  <Link to='/wishlist' className='text-gray-800 opacity-75 hover-opacity-100 hover-text-main-700 transition-2'>
                    Wishlist
                  </Link>
                </li>
                <li className='mb-16'>
                  <Link to='/cart' className='text-gray-800 opacity-75 hover-opacity-100 hover-text-main-700 transition-2'>
                    Shopping Cart
                  </Link>
                </li>
                <li className='mb-16'>
                  <Link to='/checkout' className='text-gray-800 opacity-75 hover-opacity-100 hover-text-main-700 transition-2'>
                    Checkout
                  </Link>
                </li>
              </ul>
            </div>
            <div className='footer-item'>
              <h6 className='footer-item__title text-main-600 fw-bold'>Contact Details</h6>
              <div className='flex-align gap-16 mb-16'>
                <span className='w-32 h-32 flex-center rounded-circle border border-main-600 border-opacity-25 text-main-600 text-md flex-shrink-0'>
                  <i className='ph-fill ph-phone-call' />
                </span>
                <a href='tel:9940075399' className='text-md text-gray-800 opacity-75 hover-opacity-100'>
                  +91 99400 75399
                </a>
              </div>
              <div className='flex-align gap-16 mb-16'>
                <span className='w-32 h-32 flex-center rounded-circle border border-main-600 border-opacity-25 text-main-600 text-md flex-shrink-0'>
                  <i className='ph-fill ph-envelope' />
                </span>
                <a href='mailto:culturevedhas@gmail.com' className='text-md text-gray-800 opacity-75 hover-opacity-100'>
                  culturevedhas@gmail.com
                </a>
              </div>
              <div className='flex-align gap-16 mb-16'>
                <span className='w-32 h-32 flex-center rounded-circle border border-main-600 border-opacity-25 text-main-600 text-md flex-shrink-0'>
                  <i className='ph-fill ph-map-pin' />
                </span>
                <a
                  href='https://maps.google.com/?q=11.322122,77.685051'
                  target='_blank'
                  rel='noopener noreferrer'
                  className='text-md text-gray-800 opacity-75 hover-opacity-100'
                >
                  123, Sakthinagar 4th cross left, Thindal, Erode
                </a>
              </div>
            </div>

            <div className='footer-item'>
              <h6 className='footer-item__title text-main-600 fw-bold'>Shop on The Go</h6>
              <p className='mb-16 text-gray-800 opacity-75'>Vedha&apos;s Cultures App is available on.</p>
              <div className='flex-align gap-8 my-20'>
                <Link
                  to='https://play.google.com/store/apps/details?id=com.pepsoftware.vedhasculture'
                  className=''
                  target="_blank" 
                >
                  <img src='/assets/images/icon/store-img2.png' width={120} alt='' />
                </Link>
              </div>

              <h6 className='footer-item__title mt-24 text-main-600 fw-bold'>Connect with Us</h6>
              <p className='mb-16 text-gray-800 opacity-75'>Follow us on social media for updates</p>
              <ul className='flex-align gap-16 mt-24'>
                <li>
                  <Link
                    to='https://www.facebook.com/'
                    className='w-44 h-44 flex-center bg-main-600 text-white text-xl rounded-8 transition-2'
                  >
                    <i className='ph-fill ph-facebook-logo' />
                  </Link>
                </li>
                <li>
                  <Link
                    to='https://www.instagram.com/vedhasculture'
                    target='_blank'
                    rel='noreferrer'
                    className='w-44 h-44 flex-center bg-main-600 text-white text-xl rounded-8 transition-2'
                  >
                    <i className='ph-fill ph-instagram-logo' />
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </footer>
      {/* bottom Footer */}
      <div className='bottom-footer bg-white py-0'>
        <div className='container container-lg'>
          <div className='bottom-footer__inner d-flex justify-content-center flex-wrap gap-16 py-8'>
            <p className='bottom-footer__text '>
              Vedha's Culture © {new Date().getFullYear()}. All Rights Reserved | Developed by <a href="https://pepsoftwares.com" target="_blank" rel="noreferrer" className="text-main-600 hover-text-main-700">pepsoftwares.com</a>
            </p>
          </div>
        </div>
      </div>
      {/* ==================== Footer Two End Here ==================== */}
    </>
  );
};

export default Footer;